module.exports = __webpack_public_path__ + "static/media/GF.9f722c61.jpg";